import { render, staticRenderFns } from "./ProblemLog.vue?vue&type=template&id=95192b98&scoped=true&"
import script from "./ProblemLog.vue?vue&type=script&lang=ts&"
export * from "./ProblemLog.vue?vue&type=script&lang=ts&"
import style0 from "./ProblemLog.vue?vue&type=style&index=0&id=95192b98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95192b98",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCheckbox,VIcon,VSelect,VTooltip})
